import * as React from "react"

const SvgComponent = (props) => (
  <svg
    viewBox="17 17 61 61"
    xmlSpace="preserve"
    xmlns="http://www.w3.org/2000/svg"
    fill="#FFFFFF"
    {...props}
  >
    <path d="m36.682 45.397-.002.001-.002.004c-.137.139-.24.307-.324.486a1.297 1.297 0 0 0-.057.133c-.018.046-.043.088-.057.137l-4.008 14.826a1.703 1.703 0 0 0 2.083 2.084l14.256-3.853c.094.016.184.055.279.055.436 0 .871-.166 1.203-.498l23.086-23.088a6.48 6.48 0 0 0 1.91-4.609 6.48 6.48 0 0 0-1.91-4.609l-4.154-4.154c-2.461-2.463-6.76-2.459-9.217 0L36.682 45.397zm25.492-20.682c1.174-1.177 3.23-1.176 4.408.001l4.154 4.153c.59.589.914 1.372.914 2.206s-.324 1.616-.914 2.206l-1.25 1.25-8.564-8.563 1.252-1.253zm-3.656 3.657 8.564 8.563-18.23 18.231-8.566-8.564 18.232-18.23zM39.285 50.407l6.137 6.138-9.135 2.471 2.469-9.136.529.527z" />
    <path d="m58.293 34.755 2.405 2.404-10.667 10.67-2.404-2.405z" />
    <path d="M20.961 74.166h45.74a6.525 6.525 0 0 0 6.518-6.52V44.628H69.82v23.019a3.121 3.121 0 0 1-3.119 3.119H22.662V25.662h29.012v-3.4H20.961c-.939 0-1.699.761-1.699 1.7v48.503a1.7 1.7 0 0 0 1.699 1.701z" />
  </svg>
)

export default SvgComponent
